import { IZone } from '../custom/classes/production';
import { IPwycPerformanceSettings } from '../classes/package-listing';


export function sumPrices(zone: IZone, priceTypeQuantities: Map<number, number>,
    pwycAmounts?: Map<string, number>, performanceId?: number, pwycSettings?: IPwycPerformanceSettings) {
    let prices = [];
    let foundAllPriceTypes = true;
    priceTypeQuantities.forEach((quantity, ptId) => {
        // AAC26-75 - Use PWYC amount if available for this perf/priceType combo
        const pwycKey = performanceId != null ? `${performanceId}_${ptId}` : null;
        const hasPwycAmount = pwycKey && pwycAmounts && pwycAmounts.has(pwycKey);
        const isPwycEligible = pwycSettings && pwycSettings.usePayWhatYouCan
            && (pwycSettings.pwycPriceTypeIds.length === 0 || pwycSettings.pwycPriceTypeIds.indexOf(ptId) >= 0)
            && (pwycSettings.pwycZoneIds.length === 0 || pwycSettings.pwycZoneIds.indexOf(zone.zone.id) >= 0);

        if (hasPwycAmount && isPwycEligible) {
            const pwycAmount = pwycAmounts.get(pwycKey);
            for (let i = 0; i < quantity; i++) {
                prices.push(pwycAmount);
            }
        } else {
            const matchedPrice = zone.prices.filter(pr => pr.priceTypeId === ptId);
            if (matchedPrice.length > 0) {
                for (let i = 0; i < quantity; i++) {
                    prices.push(matchedPrice.map(pr => pr.price).reduce((total, num) => total + num, 0));
                }
            }
            else {
                foundAllPriceTypes = false;
            }
        }
    });

    const priceSum = prices.reduce((total, num) => total + num, 0);
    return { priceSum, foundAllPriceTypes };
}


